/**
 * Analytic stirage key constants.
 * @property {USER_ID} USER_ID - User Id localstorage key
 * @property {USER_TRAITS} USER_TRAITS - User traits localstorage key
 */

/**
 * User Id localstorage key
 */
export const USER_ID = `__user_id`;
/**
  * User traits localstorage key
  */
export const USER_TRAITS = `__user_traits`;

export const tempKey = (key) => `__TEMP__${key}`;
